export const MODAL_TYPES = {
  CREATE_PRODUCT: "CREATE_PRODUCT",
  EDIT_PRODUCT: "EDIT_PRODUCT",
  EDIT_PRODUCT_VARIANTS: "EDIT_PRODUCT_VARIANTS",
  CREATE_CATEGORY: "CREATE_CATEGORY",
  EDIT_CATEGORY: "EDIT_CATEGORY",
  CREATE_MASTER: "CREATE_MASTER",
  EDIT_MASTER: "EDIT_MASTER",
  EDIT_USER: "EDIT_USER",
  RESET_USER_PASSWORD: "RESET_USER_PASSWORD",
  VIEW_ORDER_DETAILS: "VIEW_ORDER_DETAILS",
  VIEW_ENQUIRY_DETAILS: "VIEW_ENQUIRY_DETAILS",
};
